export const APP_BRAND_NAME = 'Retail Radar';
export const APP_LOGO_PATH = '/assets/images/retailradar-logo.svg';
export const CONTENT_IMAGE_FALLBACK_PATH =
  '/assets/images/content-placeholder.svg';
